import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import DatePicker from "react-datepicker2";
import moment from 'moment-jalaali';
import axios from 'axios';
import { trackPromise } from "react-promise-tracker";

// فرم نسخه: شماره، تاریخ انتشار، و فهرست قابلیت ها.
//
// قابلیت ها یکجا جایگزین می شوند - همان چیزی که سرور هم انجام می دهد. چون
// هر قابلیت فقط یک عنوان است، ویرایش سطر به سطر ارزشی ندارد و فقط فرم را
// سنگین می کند.
const VersionProp = forwardRef((props, ref) => {

    //#region const

    const [Id, setId] = useState(General.GuidEmpty());
    const [Version, setVersion] = useState("");
    const [ReleaseDate, setReleaseDate] = useState(null);
    const [Features, setFeatures] = useState([""]);
    const [ShowLoader, setShowLoader] = useState(false);
    //#endregion

    //#region Methods

    useImperativeHandle(ref, () => ({
        ShowEdit(EditId) {
            setId(EditId);
            setVersion("");
            setReleaseDate(null);
            setFeatures([""]);
        }
    }))

    const ChangeFeature = (index, value) => {
        const list = [...Features];
        list[index] = value;
        setFeatures(list);
    }

    const AddFeature = () => {
        setFeatures([...Features, ""]);
    }

    const RemoveFeature = (index) => {
        const list = Features.filter((item, i) => i !== index);
        //--> همیشه دست کم یک ردیف خالی بماند وگرنه راهی برای شروع دوباره نیست
        setFeatures(list.length > 0 ? list : [""]);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (Version === "") {
            General.ShowMsg(Enum.MsgType.error, "شماره نسخه را وارد نمایید");
            return;
        }
        if (!ReleaseDate) {
            General.ShowMsg(Enum.MsgType.error, "تاریخ انتشار را مشخص نمایید");
            return;
        }
        const filled = Features.filter(item => item && item.trim() !== "");
        if (filled.length === 0) {
            General.ShowMsg(Enum.MsgType.error, "دست کم یک قابلیت وارد نمایید");
            return;
        }

        setShowLoader(true);
        var RequestOption = {
            method: 'Post',
            url: General.ApiRoute() + '/ProjectVersion/Save',
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
            data: {
                "Id": Id,
                "ProjectId": props.projectId,
                "Version": Version,
                "ReleaseDate": ReleaseDate.format('jYYYY/jMM/jDD'),
                "Features": filled.map((title, index) => ({
                    "Id": General.GuidEmpty(),
                    "ProjectVersionId": Id,
                    "Title": title,
                    "Sort": index + 1
                }))
            },
            withCredentials: true
        }
        trackPromise(
            axios(RequestOption)
                .then(function (res) {
                    setShowLoader(false);
                    if (res.data.isSuccess) {
                        General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                        props.onSubmit();
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, res.data.error);
                    }
                })
                .catch(error => {
                    setShowLoader(false);
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());
                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
                        }
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    }
                })
        )
    };

    const BindVersion = () => {
        setShowLoader(true);
        var RequestOption = {
            method: 'Get',
            url: General.ApiRoute() + "/ProjectVersion/GetById",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setVersion(res.data.version);
                setReleaseDate(moment(res.data.releaseDate, 'jYYYY/jMM/jDD'));
                setFeatures(
                    res.data.features && res.data.features.length > 0 ?
                        res.data.features.map(item => item.title)
                        :
                        [""]
                );
                setShowLoader(false);
            })
            .catch(error => {
                setShowLoader(false);
                if (error.response) {
                    if (error.response.status === 401) {
                        General.ShowMsg(Enum.MsgType.error, General.unAuthorize());
                    }
                    else if (error.response.status === 403) {
                        General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    useEffect(() => {
        if (Id !== General.GuidEmpty()) {
            BindVersion();
        }
    }, [Id])
    //#endregion

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>شماره نسخه</label>
                <rsuite.Input
                    type="text"
                    value={Version}
                    onChange={value => setVersion(value)}
                    placeholder="مثلا 2.1"
                    required />
                <div style={{ fontSize: 11, color: '#8c97a3', marginTop: 4 }}>
                    باید دقیقا همان چیزی باشد که نرم افزار مشتری می فرستد
                </div>
            </div>

            {/* تقویم داخل form رندر می شود و react-datepicker2 دکمه هایش را
                بدون type می سازد، یعنی پیش فرض submit. این preventDefault
                فقط جلوی ثبت شدن فرم را می گیرد. */}
            <div className='mt-3' onClick={(e) => e.preventDefault()}>
                <label>تاریخ انتشار</label>
                <DatePicker className="form-control" isGregorian={false} timePicker={false}
                    value={ReleaseDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                    onChange={(value) => setReleaseDate(value)} />
            </div>

            <rsuite.Divider>قابلیت های این نسخه</rsuite.Divider>

            {
                Features.map((item, index) => (
                    //--> ورودی تمام عرض را می گیرد و دکمه حذف کنارش می ماند
                    <rsuite.Stack key={index} spacing={8} className='mb-2' style={{ width: '100%' }}>
                        <rsuite.Stack.Item flex={1}>
                            <rsuite.Input
                                className='w-100'
                                value={item}
                                onChange={value => ChangeFeature(index, value)}
                                placeholder="عنوان قابلیت"
                            />
                        </rsuite.Stack.Item>
                        <rsuite.IconButton
                            appearance="subtle"
                            color="red"
                            onClick={() => RemoveFeature(index)}
                            icon={<span>×</span>}
                            title="حذف این ردیف"
                        />
                    </rsuite.Stack>
                ))
            }

            <rsuite.Button size="sm" appearance="ghost" onClick={AddFeature}>
                افزودن قابلیت
            </rsuite.Button>

            <rsuite.Divider />
            <div align="left">
                {
                    !ShowLoader ?
                        <rsuite.Button appearance="primary" className="mt-2" onClick={handleSubmit}>
                            ثبت نسخه
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mt-2" disabled>
                            <rsuite.Loader content="در حال ارسال اطلاعات..." />
                        </rsuite.Button>
                }
            </div>
        </form>
    );
});

export default VersionProp;
